<template>
  <div>
    <div>
      <div v-if="cancel == 0" :class="`current-inline`">
        <i :class="`fas fa-check-circle text-success`"></i>
        <span v-if="!icon" class="ml-1">Activo</span>
      </div>
      <div v-if="cancel == 1" :class="`current-inline`">
        <i :class="`fas fa-times-circle text-danger`"></i>
        <span v-if="!icon" class="ml-1">Cancelado</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "item-state",
  props: {
    icon: {
      type: Boolean,
    },
    cancel: {
      type: Number,
      default: 0,
    },
  },
  data: () => {
    return {
      steps: [
        {
          state: 0,
          icon: "fa-check-circle",
          variant: "success",
          text: "Activa",
        },
        {
          state: 1,
          icon: "fa-envelope",
          variant: "warning",
          text: "Activa",
        },
        {
          state: 2,
          icon: "fa-check-double",
          variant: "warning",
          text: "Actualizar contraseña",
        },
        {
          state: 3,
          icon: "fa-file-contract",
          variant: "success",
          text: "A.P. Firmado",
        },
      ],
    };
  },
  computed: {
    currentState: function () {
      return this.steps.find((step) => step.state == this.state);
    },
  },
};
</script>
<style lang="scss" scoped>
.steps {
  display: flex;
  list-style: none;
  .step {
    width: 100%;
    text-align: center;
    display: inline-flex;

    &:before {
      border-top: 1px solid #b9b9b9;
      display: block;
      position: relative;
      margin: 0;
      width: 30%;
      top: 33%;
      content: "";
    }

    &:after {
      border-top: 1px solid #b9b9b9;
      display: block;
      position: relative;
      margin: 0;
      width: 30%;
      top: 33%;
      content: "";
    }

    &.start {
      &:before {
        width: 0;
        // border-top: 0px solid #b9b9b9 !important;
      }
    }

    &.end {
      &:after {
        width: 0;
        // border-top: 0px solid #b9b9b9 !important;
      }
    }

    &.cancel {
      &:before {
        border-color: red;
      }
      &:after {
        border-color: red;
      }
      i {
        color: red !important;
      }
    }

    .content {
      position: relative;
      margin-left: auto;
      margin-right: auto;
      line-height: 15px;

      i {
        font-size: 1.25em;
        // height: 44px;
        // width: 44px !important;
        font-size: 1.5em;
        color: #b9b9b9;
        border-radius: 50%;
        padding-top: 11px;
        color: gray;
      }
    }

    &.completed:not(.cancel) {
      &:before {
        border-color: black;
      }

      &:after {
        border-color: black;
      }

      i {
        color: black;
      }
    }

    &.current:not(.cancel) {
      &:before {
        border-color: black;
      }

      i {
        color: #50cd89;
      }
    }
  }
}
</style>
